export const blogValidate = (addBlogData, images, selectedParent, selectedSubParent, releaseDate) => {

    const errors = {}

    if (!addBlogData.title.trim()) {
        errors.title = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.title
    }

    if (!addBlogData.slug.trim()) {
        errors.slug = "لطفا عنوان انگلیسی را وارد کنید"
    } else {
        delete errors.slug
    }

    if (!addBlogData.seoTitle.trim()) {
        errors.seoTitle = "لطفا seoTitle را وارد کنید"
    } else {
        delete errors.seoTitle
    }

    if (!addBlogData.seoDescription.trim()) {
        errors.seoDescription = "لطفا seoDescription را وارد کنید"
    } else {
        delete errors.seoDescription
    }

    if (!addBlogData.seoKeywords.trim()) {
        errors.seoKeywords = "لطفا seoKeywords را وارد کنید"
    } else {
        delete errors.seoKeywords
    }

    if (!addBlogData.seoCanonical.trim()) {
        errors.seoCanonical = "لطفا seoCanonical را وارد کنید"
    } else {
        delete errors.seoCanonical
    }

    if (!addBlogData.seoSchema.trim()) {
        errors.seoSchema = "لطفا seoSchema را وارد کنید"
    } else {
        delete errors.seoSchema
    }

    if (images == "") {
        errors.images = "لطفا عکس مقاله را انتخاب کنید"
    } else {
        delete errors.images
    }

    // if (!editorData.trim()) {
    //     errors.editor = "لطفا متن مقاله را وارد نمایید"
    // } else {
    //     delete errors.editor
    // }

    if (!selectedParent) {
        errors.selectedParent = "لطفا دسته بندی را انتخاب کنید"
    } else {
        delete errors.selectedParent
    }

    if (!selectedSubParent) {
        errors.selectedSubParent = "لطفا زیر مجموعه دسته بندی را انتخاب کنید"
    } else {
        delete errors.selectedSubParent
    }

    if (!releaseDate) {
        errors.releaseDate = "لطفا تاریخ انتشار را انتخاب کنید"
    } else {
        delete errors.releaseDate
    }

    return errors;

}